import { render } from "./FosoftechTest2.vue?vue&type=template&id=a400b40a&scoped=true"
import script from "./FosoftechTest2.vue?vue&type=script&lang=js"
export * from "./FosoftechTest2.vue?vue&type=script&lang=js"

import "./FosoftechTest2.vue?vue&type=style&index=0&id=a400b40a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a400b40a"]])

export default __exports__